/**
 * Utilities for detecting when the app is running outside Excel's task-pane
 * host — i.e. the "standalone" pop-out flow, where the same deployed addin
 * bundle is loaded in a plain browser tab via `?standalone=1&spreadsheetId=…`.
 *
 * Standalone has no access to the Excel JavaScript API: `Excel.run` is
 * unavailable, worksheet events don't fire, and the ribbon doesn't exist.
 * Callers use `isStandaloneMode()` to gate Excel-only code paths.
 *
 * The spreadsheet ID in standalone comes from `?spreadsheetId=` on the URL,
 * but consumers don't read that here — `getSpreadsheetMetadata()` in
 * `spreadsheet-metadata.service.ts` is the single entry point for "which
 * workbook are we on?" and it dispatches on host internally.
 */

/**
 * Returns true if the app is running standalone in a plain browser tab
 * (outside of Excel).
 */
export function isStandaloneMode(): boolean {
  return new URLSearchParams(window.location.search).get("standalone") === "1";
}
